export default "__VITE_ASSET__495ef456__"